function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.999 7.5 13.322 7.5 7.499 10.411 1.677 7.5 0 7.5 0 8.339 5.823 11.25 0 14.161 0 15.001 .335 15.671 7.499 12.089 14.664 15.671 15.335 14.329 9.177 11.25 15.335 8.171 14.999 7.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 7.5 13.882 7.5 7.499 10.691 1.117 7.5 0 7.5 0 8.059 6.382 11.25 0 14.441 0 15.001 .223 15.447 7.499 11.809 14.776 15.447 15.224 14.553 8.618 11.25 15.224 7.947 15 7.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.75 17.5 6.25 17.5 6.25 12.5 0 12.5 0 10 6.25 10 6.25 7.5 8.75 7.5 8.75 10 17.5 10 17.5 12.5 8.75 12.5 8.75 17.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.25 17.5 6.749 17.5 6.749 12 0 12 0 10.5 6.749 10.5 6.749 7.5 8.25 7.5 8.25 10.5 17.5 10.5 17.5 12 8.25 12 8.25 17.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.001h15v-7.501h15v15H0v-7.499Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.909 10.032 23.568 9.553 22.753 9.553 22.499 8.775 22.246 9.553 21.431 9.553 22.09 10.032 21.837 10.81 22.499 10.332 23.162 10.81 22.909 10.032",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.4 10.735 24.811 11.441 24.896 10.627 25.693 10.459 24.947 10.127 25.032 9.313 24.485 9.921 23.74 9.59 24.148 10.294 23.601 10.902 24.4 10.735",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.172 11.705 25.971 11.877 26.059 12.689 26.467 11.98 27.264 12.15 26.718 11.544 27.126 10.834 26.38 11.169 25.834 10.563 25.92 11.372 25.172 11.705",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.282 13.074 26.941 13.556 26.691 14.334 27.353 13.854 28.011 14.333 27.759 13.557 28.42 13.077 27.602 13.075 27.35 12.3 27.1 13.074 26.282 13.074",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.945 15.317 28.031 14.506 27.486 15.111 26.738 14.778 27.144 15.487 26.599 16.096 27.399 15.926 27.805 16.632 27.891 15.821 28.691 15.65 27.945 15.317",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.752 16.795 27.007 17.127 26.46 16.52 26.543 17.333 25.798 17.668 26.598 17.838 26.682 18.648 27.09 17.942 27.891 18.112 27.343 17.501 27.752 16.795",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.751 18.779 25.498 18.001 25.242 18.777 24.426 18.779 25.088 19.26 24.836 20.035 25.497 19.555 26.159 20.036 25.905 19.258 26.565 18.778 25.751 18.779",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.02 18.963 23.471 19.568 22.723 19.238 23.133 19.946 22.587 20.551 23.385 20.381 23.794 21.089 23.88 20.274 24.678 20.105 23.933 19.775 24.02 18.963",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.275 19.237 21.528 19.567 20.979 18.961 21.066 19.776 20.321 20.106 21.119 20.275 21.206 21.089 21.614 20.38 22.412 20.549 21.866 19.945 22.275 19.237",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.573 18.779 19.757 18.777 19.501 18.001 19.248 18.779 18.434 18.778 19.094 19.258 18.841 20.036 19.502 19.555 20.163 20.035 19.911 19.26 20.573 18.779",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.457 17.336 18.54 16.523 17.993 17.131 17.248 16.798 17.657 17.504 17.109 18.112 17.91 17.945 18.318 18.651 18.402 17.841 19.202 17.671 18.457 17.336",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.197 16.633 17.603 15.927 18.403 16.097 17.858 15.488 18.264 14.779 17.517 15.113 16.972 14.507 17.057 15.318 16.309 15.65 17.112 15.822 17.197 16.633",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.989 14.334 17.647 13.855 18.309 14.336 18.059 13.557 18.718 13.076 17.9 13.076 17.65 12.301 17.398 13.077 16.58 13.077 17.241 13.559 16.989 14.334",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.534 11.978 18.942 12.687 19.03 11.875 19.829 11.702 19.081 11.37 19.167 10.56 18.621 11.167 17.874 10.834 18.283 11.541 17.737 12.148 18.534 11.978",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.104 10.627 20.189 11.441 20.6 10.735 21.399 10.902 20.852 10.294 21.26 9.59 20.515 9.921 19.968 9.313 20.053 10.127 19.307 10.459 20.104 10.627",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/CK.d3ca2439493e01322abb3d2431286d44.svg";
export { ForwardRef as ReactComponent };